export default {
  path: '/certificados-de-calibracao',
  component: () => import('@/components/pages/CalibrationCertificates/CalibrationCertificates')
}
